import { Tab, Typography } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import CustomersTab from "components/userManagement/CustomersTab";
import GroupsTab from "components/userManagement/GroupsTab";
import UsersTab from "components/userManagement/UsersTab";
import { observer } from "mobx-react";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useStore } from "store/StoreConfigs";
import { userViewStyles } from "./UserViewStyles";

export default observer(function UserView() {
    const [value, setValue] = useState("customers");
    const { commonStore } = useStore();
    const classes = userViewStyles();

    useEffect(() => {
        commonStore.setCurrentView("user");
    }, []);

    function handleChange(event: ChangeEvent<{}>, newValue: string) {
        setValue(newValue);
    }

    return (
        <main className={classes.content}>
            <Typography className={classes.title}>User management</Typography>
            <TabContext value={value}>
                <TabList onChange={handleChange} aria-label="user-management-tabs">
                    <Tab label="Customers" value="customers" />
                    <Tab label="Groups" value="groups" />
                    <Tab label="Users" value="users" />
                </TabList>
                <TabPanel value="customers">
                    <CustomersTab />
                </TabPanel>
                <TabPanel value="groups">
                    <GroupsTab />
                </TabPanel>
                <TabPanel value="users">
                    <UsersTab />
                </TabPanel>
            </TabContext>
        </main>
    );
});
